import http from './api'

const route = 'app/mixmedio/'

export default {
  showGraficoMixMedioGeral: (dataInicial, dataFinal, empresaSelect, produtos, vendedores, redes, tokencontrato, areas, segmento) => {
    return http.post(route + 'showGraficoMixMedioGeral', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      empresas: empresaSelect,
      produtos: produtos,
      vendedores: vendedores,
      redes: redes,
      tokenContrato: tokencontrato,
      areas: areas,
      segmento: segmento,
    })
  },

  showDadosTabelaMixMedioGeral: (data, semanas, empresaSelect, produtos, vendedores, redes, tokencontrato, areas, segmento) => {
    return http.post(route + 'showDadosTabelaMixMedioGeral', {
      data: data,
      semanas: semanas,
      empresas: empresaSelect,
      produtos: produtos,
      vendedores: vendedores,
      redes: redes,
      tokenContrato: tokencontrato,
      areas: areas,
      segmento: segmento,
    })
  },

  showGraficoMixMedioCidade: (dataInicial, dataFinal, empresaSelect, produtos, vendedores, redes, cidades, areas, tokencontrato, segmento) => {
    return http.post(route + 'showGraficoMixMedioCidade', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      empresas: empresaSelect,
      produtos: produtos,
      vendedores: vendedores,
      redes: redes,
      cidades: cidades,
      areas: areas,
      tokenContrato: tokencontrato,
      segmento: segmento,
    })
  },

  showDadosTabelaMixMedioCidade: (data, semanas, empresaSelect, produtos, vendedores, redes, cidades, areas, tokencontrato, segmento) => {
    return http.post(route + 'showDadosTabelaMixMedioCidade', {
      data: data,
      semanas: semanas,
      empresas: empresaSelect,
      produtos: produtos,
      vendedores: vendedores,
      redes: redes,
      cidades: cidades,
      areas: areas,
      tokenContrato: tokencontrato,
      segmento: segmento,
    })
  },
}
